// @flow

import React from 'react';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';
import marketingApi from '../../../../network/api/marketingApi';
import EllipsisLoader from '../../../../components/EllipsisLoader';
import StoresVisited from '../MonthlyLoyaltySurvey/StoresVisited';
import SpendingBasketCategories from '../MonthlyLoyaltySurvey/SpendingBasketCategories';
import AnnualStatistics from '../MonthlyLoyaltySurvey/AnnualStatistics';
import MarketingEmptyTile from './MarketingEmptyTile';
import type { LoyaltySurvey } from '../../../../types/marketingType';
import { notifyApolloError } from '../../../../network/notification';

type Props = {
  dispatch: () => void,
  shoppingCenter: ShoppingCenter,
};

type State = {
  monthlyLoyaltySurvey: LoyaltySurvey,
  isLoading: boolean,
};

class MonthlyLoyaltySurvey extends React.Component<Props, State> {
  state: State = {
    isLoading: true,
    monthlyLoyaltySurvey: null,
  }

  componentDidMount() {
    marketingApi.getMonthlyLoyaltySurvey(this.props.shoppingCenter.id)
      .then(response => response.json())
      .then((monthlyLoyaltySurvey: LoyaltySurvey) => this.setState({ monthlyLoyaltySurvey }))
      .catch(e => this.props.dispatch(notifyApolloError(e)))
      .finally(() => this.setState({ isLoading: false }));
  }

  render() {
    if (this.state.isLoading) {
      return (
        <EllipsisLoader />
      );
    }
    if (!this.state.monthlyLoyaltySurvey) {
      return (
        <MarketingEmptyTile errorMessage="MKT_PAGE.monthly_survey.NO_DATA" />
      );
    }

    const {
      storesVisited,
      spendingBasketCategories,
      annualStatistics,
    } = this.state.monthlyLoyaltySurvey;
    const displayStoreVisited = storesVisited && storesVisited.nbResponses > 0;
    const displaySpendingBasketCategories = spendingBasketCategories && spendingBasketCategories.nbResponses > 0;
    const displayAnnualStatistics = !!annualStatistics;

    if (!displayStoreVisited && !displaySpendingBasketCategories && !displayAnnualStatistics) {
      return (
        <MarketingEmptyTile errorMessage="MKT_PAGE.monthly_survey.NO_DATA" />
      );
    }

    return (
      <div className="monthly-loyalty-survey">
        <div className="monthly-loyalty-survey-content">
          {displayStoreVisited &&
          <StoresVisited storesVisited={storesVisited} />
          }
          {
            displaySpendingBasketCategories &&
            <SpendingBasketCategories basketCategories={spendingBasketCategories} />
          }
        </div>
        <div>
          {
            displayAnnualStatistics &&
            <AnnualStatistics
              annualStatisticsN={annualStatistics.sort((a, b) => a.year > b.year)[0]}
              annualStatisticsN1={annualStatistics.sort((a, b) => a.year > b.year)[1]}
            />
          }
        </div>
      </div>
    );
  }
}

export default MonthlyLoyaltySurvey;
